"use client";

import { c as _c } from "react/compiler-runtime";
import { Play, Pause, Loader2, RotateCcw, RotateCw } from "lucide-react";
interface AudioPlayerControlsProps {
  isPlaying: boolean;
  isLoading: boolean;
  audioUrl: string | null;
  onTogglePlay: () => void;
  onSkip: (seconds: number) => void;
}
export function AudioPlayerControls(t0) {
  const $ = _c(26);
  const {
    isPlaying,
    isLoading,
    audioUrl,
    onTogglePlay,
    onSkip
  } = t0;
  let t1;
  if ($[0] !== onSkip) {
    t1 = () => onSkip(-30);
    $[0] = onSkip;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !audioUrl || isLoading;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <RotateCcw className="size-5" />;
    t4 = <span className="text-[10px] font-bold mt-0.5">30</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2) {
    t5 = <button onClick={t1} disabled={t2} className="p-1 text-slate-500 hover:text-primary dark:text-slate-400 dark:hover:text-primary transition-colors disabled:opacity-50 flex flex-col items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg" aria-label="Skip back 30 seconds">{t3}{t4}</button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isPlaying ? "Pause" : "Play";
  let t7;
  if ($[7] !== isLoading || $[8] !== isPlaying) {
    t7 = isLoading ? <Loader2 className="size-6 animate-spin" /> : isPlaying ? <Pause className="size-6 fill-current" /> : <Play className="size-6 fill-current ml-1" />;
    $[7] = isLoading;
    $[8] = isPlaying;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isLoading || $[11] !== onTogglePlay || $[12] !== t6 || $[13] !== t7) {
    t8 = <button onClick={onTogglePlay} disabled={isLoading} className="flex items-center justify-center size-12 bg-primary hover:bg-primary/90 rounded-full text-white shadow-lg shadow-primary/25 transition-transform hover:scale-105 active:scale-95 disabled:opacity-70 disabled:hover:scale-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/20" aria-label={t6}>{t7}</button>;
    $[10] = isLoading;
    $[11] = onTogglePlay;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== onSkip) {
    t9 = () => onSkip(30);
    $[15] = onSkip;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = !audioUrl || isLoading;
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <RotateCw className="size-5" />;
    t12 = <span className="text-[10px] font-bold mt-0.5">30</span>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t10 || $[20] !== t9) {
    t13 = <button onClick={t9} disabled={t10} className="p-1 text-slate-500 hover:text-primary dark:text-slate-400 dark:hover:text-primary transition-colors disabled:opacity-50 flex flex-col items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg" aria-label="Skip forward 30 seconds">{t11}{t12}</button>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t5 || $[24] !== t8) {
    t14 = <div className="flex items-center justify-center gap-6 mt-1">{t5}{t8}{t13}</div>;
    $[22] = t13;
    $[23] = t5;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}